import { IconType } from 'src/components/shared/custom-icon/custom-icon';
import { FeatureName } from 'src/utils/enums';
import { DnsExceptionLink } from './dns-exceptions-link';

export interface ThreatFeatureStructure {
    explain: string,
    icon: IconType,
    keyForGetValue?: string,
    nameForUpdate?: FeatureName,
    additionalExplain?: (value: string) => JSX.Element,
    key?: string,
    type: 'select' | 'toggle'
}

export const dynamicDefenseShieldFeature: ThreatFeatureStructure = {
    key: 'Dynamic Defense Shield',
    explain: 'Proactive global IP block list powered by AT&T',
    icon: IconType.DYNAMIC_DEFENSE,
    keyForGetValue: 'Dynamic Defense Shield',
    type: 'toggle'
};

export const virusProtectionFeature: ThreatFeatureStructure = {
    key: 'Virus Protection',
    explain: 'Protect against viruses, worms, and trojans as well as spyware downloads.',
    icon: IconType.VIRUS_PROTECTION,
    nameForUpdate: FeatureName.VIRUS_PROTECTION,
    keyForGetValue: 'antiVirus',
    type: 'select'
};

export const spywareProtectionFeature: ThreatFeatureStructure = {
    key: 'Spyware Protection',
    explain: 'Blocks spyware on compromised hosts from trying to phone-home or beacon out ' +
        'to external command-and-control (C2) servers, allowing you to detect malicious ' +
        'traffic leaving the network from infected clients.',
    icon: IconType.SPYWARE_PROTECTION,
    nameForUpdate: FeatureName.SPYWARE_PROTECTION,
    keyForGetValue: 'antiSpyware',
    type: 'select'
};

export const dnsProtectionFeature: ThreatFeatureStructure = {
    key: 'DNS Protection',
    explain: 'Protects from harmful and suspicious domains and ensures secure browsing. ',
    icon: IconType.DNS_PROTECTION_ICON,
    nameForUpdate: FeatureName.DNS,
    keyForGetValue: 'dns',
    additionalExplain: (value: string) => <DnsExceptionLink value={value} />,
    type: 'select'
};

export const vulnerabilityProtectionFeature: ThreatFeatureStructure = {
    key: 'Vulnerability Protection',
    explain: 'Stops attempts to exploit system flaws or gain unauthorized access to systems.',
    icon: IconType.VULNERABILITY_PROTECTOIN,
    nameForUpdate: FeatureName.VULNERABILITY_PROTECTION,
    keyForGetValue: 'vulnerabilityProtection',
    type: 'select'
};